<template>
  <page-layout>
    <div class="project-manager-wrapper">
      <div class="content-top">
        <div v-if="projectManager" class="info x-card">
          <h3>项目经理详情</h3>
          <div>
            <div class="basic-info">
              <div class="info-top">
                <div class="avatar-wrapper">
                  <a-avatar :src="projectManager.avatar" :size="58"></a-avatar>
                </div>
                <div class="t-c">
                  <div class="name">{{ projectManager.name }}</div>
                  <div class="auth">
                    <a-icon
                      :style="{ marginRight: '5px', color: projectManager.state === 'accepted' ? '#c8161e' : '#bfbfbf' }"
                      :type="projectManager.state === 'accepted' ? 'check-circle' : 'close-circle'"
                      theme="filled"
                    />
                    {{ projectManager.state === 'accepted' ? '已认证' : '未认证' }}
                  </div>
                </div>
                <div class="operate">
                  <a-switch checkedChildren="√" unCheckedChildren="×" v-model="authorized"/>
                </div>
              </div>
              <div class="fields">
                <a-row :gutter="24">
                  <a-col
                    :span="12"
                  >院系：{{ projectManager.departments && projectManager.departments.join(' / ') }}</a-col>
                  <a-col :span="12">注册时间：{{ projectManager.created_at | moment('YYYY-MM-DD') }}</a-col>
                  <a-col :span="12">联系电话：{{ projectManager.mobile }}</a-col>
                  <a-col :span="12">联系邮箱：{{ projectManager.email }}</a-col>
                  <a-col
                    :span="24"
                  >所在地：{{ projectManager.location && projectManager.location.join(' / ') }}</a-col>
                  <a-col :span="24">
                    关注的技术领域：
                    <div class="tags">
                      <a-tag
                        v-for="item in projectManager.interested_technology_areas"
                        color="blue"
                        :key="item"
                      >{{ item }}</a-tag>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    关注的行业：
                    <div class="tags">
                      <a-tag
                        v-for="item in projectManager.interested_industries"
                        color="cyan"
                        :key="item"
                      >{{ item }}</a-tag>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    个人简介：
                    <div class="desc">{{ projectManager.short_description }}</div>
                  </a-col>
                </a-row>
              </div>
            </div>
            <div class="statistics">
              <div class="item">
                <div class="num">{{ projectManager.projects_created_count }}</div>
                <div class="label">发起的项目</div>
              </div>
              <div class="item">
                <div class="num">{{ projectManager.projects_participated_count }}</div>
                <div class="label">参与的项目</div>
              </div>
              <div class="item">
                <div class="num">{{ projectManager.projects_applying_count }}</div>
                <div class="label">申请中的项目</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="projectMoments" class="moments x-card">
          <h3>项目经理动态</h3>
          <div class="timeline-wrapper">
            <a-timeline>
              <template v-for="(item, index) in projectMoments">
                <a-timeline-item :key="index">
                  <a-tag color="#FDE9EA">
                    <span style="color: #F4282D;">{{ item.created_at | moment }}</span>
                  </a-tag>
                  <div>
                    <router-link
                      :to="{ name: 'ProjectDetail', params: { projectId: item.project.id } }"
                    >
                      <div class="project-link">{{ item.project.name }}</div>
                    </router-link>
                    {{ item.content }}
                  </div>
                </a-timeline-item>
              </template>
            </a-timeline>
            <div style="margin-top: 20px">
              <a-button
                v-if="momentPagination.count > projectMoments.length"
                @click="showMoreMoments"
              >加载更多 ▼</a-button>
              <a-button disabled v-else>没有更多动态了</a-button>
            </div>
          </div>
        </div>
      </div>
      <div class="projects x-card">
        <h3>参与的项目</h3>
        <x-filter :filters="filtersConfig" @chosen="chosen"></x-filter>
        <a-list class="project-list" :grid="{ gutter: 16, column: 4 }" :dataSource="projects">
          <a-list-item slot="renderItem" slot-scope="item">
            <project-item :data="item" :key="item.id"></project-item>
          </a-list-item>
        </a-list>
        <div style="margin: 15px 0;text-align: right">
          <a-pagination
            :defaultCurrent="projectPagination.page_no"
            :total="projectPagination.count"
            :pageSize="projectPagination.page_size"
            @change="pageChange"
          />
        </div>
      </div>
    </div>
  </page-layout>
</template>

<script>
import { Projects, ProjectManagers, ProjectMoments } from '@/resources'
import PageLayout from '@/components/page/PageLayout'
import ProjectItem from '@/components/ProjectItem'
import xFilter from '@/components/xFilter'

export default {
  components: { PageLayout, ProjectItem, xFilter },
  data () {
    return {
      projectManager: null,
      projectMoments: [],
      projects: [],
      momentPagination: {
        page_no: 1,
        page_size: 10,
        count: 0
      },
      projectPagination: {
        page_no: 1,
        page_size: 8,
        count: 0
      },
      filters: {
        scope: 'created'
      },
      filtersConfig: [
        {
          title: '项目类型',
          key: 'scope',
          default: 'created',
          options: [
            {
              label: '他发起的',
              value: 'created'
            },
            {
              label: '他加入的',
              value: 'participated'
            },
            {
              label: '他申请中的',
              value: 'applying'
            }
          ]
        }
      ]
    }
  },
  computed: {
    projectManagerId () {
      const vm = this
      return vm.$route.params.projectManagerId
    },
    authorized: {
      get () {
        const vm = this
        return vm.projectManager.state === 'accepted'
      },
      set (val) {
        const vm = this
        if (val) {
          vm.agree()
        } else {
          vm.reject()
        }
      }
    }
  },
  created () {
    const vm = this
    vm.fetchData()
  },
  methods: {
    fetchData () {
      const vm = this
      vm.fetchProjectManagerInfo()
      vm.fetchProjectMoments()
      vm.fetchProjects()
    },
    async fetchProjectManagerInfo () {
      const data = await ProjectManagers.find(this.projectManagerId)
      if (data) {
        this.projectManager = data.project_manager
      }
    },
    async fetchProjectMoments () {
      const data = await ProjectMoments.listOfProjectManager(this.projectManagerId, this.momentPagination)
      if (data) {
        const moments = [...data.project_moments]
        moments.forEach(item => {
          item.content = item.content.includes(this.projectManager.name)
            ? item.content.replace(this.projectManager.name, '').trim()
            : item.content.trim()
        })
        this.projectMoments.push(...moments)
        this.momentPagination.count = data.page_info.count
      }
    },
    async fetchProjects () {
      const data = await Projects.listOfProjectManager(this.projectManagerId, { ...this.projectPagination, ...this.filters })
      if (data) {
        this.projects = data.projects
        this.projectPagination.count = data.page_info.count
      }
    },
    agree () {
      ProjectManagers.accept(this.projectManagerId).then(() => {
        this.$message.success('操作成功')
        this.projectManager.state = 'accepted'
      })
    },
    reject () {
      ProjectManagers.reject(this.projectManagerId).then(() => {
        this.$message.success('操作成功')
        this.projectManager.state = null
      })
    },
    showMoreMoments () {
      const vm = this
      vm.momentPagination.page_no++
      vm.fetchProjectMoments()
    },
    chosen ({ key, value }) {
      const vm = this
      vm.filters[key] = value
      vm.fetchProjects()
    },
    pageChange (current) {
      const vm = this
      vm.projectPagination.page_no = current
      vm.fetchProjects()
    }
  }
}
</script>

<style scoped lang="less">
.project-manager-wrapper {
  .content-top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .info {
      width: 58.5%;
      > div {
        display: flex;
        > * {
          background-color: #fafafa;
          border-radius: 8px;
        }
        .basic-info {
          flex-grow: 1;
          padding: 20px;
          margin-right: 15px;
          box-sizing: border-box;
          .info-top {
            display: flex;
            align-items: flex-end;
            margin-bottom: 25px;
            .avatar-wrapper {
              min-width: 58px;
            }
            .t-c {
              flex-grow: 1;
              margin: 0 24px;
              .name {
                font-size: 16px;
                font-weight: 800;
                color: rgba(51, 51, 51, 1);
                line-height: 22px;
                margin-bottom: 6px;
              }
              .auth {
                font-size: 12px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 20px;
              }
            }
            .operate {
              min-width: 50px;
            }
          }
          .fields {
            .ant-row {
              > * {
                &:not(:last-child) {
                  margin-bottom: 15px;
                }
                font-size: 16px;
                color: rgba(102, 102, 102, 1);
                line-height: 22px;
                .tags {
                  margin-top: 10px;
                  height: 51px;
                  overflow: hidden;
                  > * {
                    margin-bottom: 5px;
                  }
                }
                .desc {
                  margin-top: 10px;
                  overflow: hidden;
                  height: 64px;
                }
              }
            }
          }
        }
        .statistics {
          min-width: 140px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .item {
            text-align: center;
            .num {
              font-size: 40px;
              font-weight: 800;
              color: rgba(51, 51, 51, 1);
              line-height: 56px;
            }
            .label {
              font-size: 16px;
              color: rgba(51, 51, 51, 1);
              line-height: 22px;
            }
          }
        }
      }
    }
    .moments {
      width: 40%;
      .timeline-wrapper {
        height: 405px;
        padding-top: 10px;
        overflow: auto;
        .project-link {
          padding: 10px 0;
          font-size: 18px;
          font-weight: 700;
          color: #666;
          &:hover {
            color: #c8161e;
          }
        }
      }
    }
  }
  .projects {
  }
}
</style>
